class BaseRouterGuard {}

export default BaseRouterGuard
